// extracted by mini-css-extract-plugin
export default {"icon":"profileMenu_icon__VimVD"};